import type { RnStatus } from "./auth";

/**
 * Should the home screen show the compliance banner at all?
 *
 * Compliance is about KEEPING an active nurse's documents current. An applicant
 * is still handing hers in, so warning her that a document is "expiring soon" —
 * directly beneath the "Complete onboarding" button asking for that very
 * document — reads as a fault of hers when it is not. Saba Saeed saw exactly
 * that mid-application.
 *
 * Unknown status (`null`) still shows. That only happens on an older cached
 * login, and the safe direction is to fail open: a spurious banner is a
 * nuisance, a missing one lets a real expiry pass unseen.
 *
 * Type-only import on purpose — this module must stay free of React Native
 * imports so it can be unit-tested without the Expo runtime.
 */
export function shouldShowComplianceBanner(rnStatus: RnStatus | null | undefined): boolean {
    return rnStatus !== "pending_application";
}
